const NewsletterBox = () => {
  const onSubmitHandler = (event) => {
    event.preventDefault();
  };

  return (
    <div className="text-center">
      <p className="text-2xl md:text-3xl lg:text-4xl font-medium text-prime-red playfair-display italic ">
        Subscribe now & get 20% off
      </p>
      <p className="text-gray-400 mt-3 montserrat">
        Lorem ipsum dolor sit, amet consectetur adipisicing elit.
      </p>
      <form
        onSubmit={onSubmitHandler}
        className="w-full md:w-2/3 lg:w-2/4 flex items-center gap-3 mx-auto my-6 border-2 border-zinc-300/80 pl-3 p-2 rounded-full"
      >
        <input
          className="w-full md:flex-1 outline-none text-lg pl-2"
          type="email"
          placeholder="Enter your email"
          required
        />
        <button
          type="submit"
          className="bg-black text-white text-sm md:text-lg px-10 py-4 cursor-pointer hover:bg-transparent hover:text-prime-red transition2 hover:outline-2 outline-prime-red rounded-full"
        >
          SUBSCRIBE
        </button>
      </form>
    </div>
  );
};

export default NewsletterBox;
